import React from 'react'
import styled from 'styled-components';

const TableBasic = styled.table`
    border-collapse: collapse;
    width: 100%;
    border: 4px solid #495057;
    min-width: 300px;
    font-weight: 600;
    /* :nth-child(even){
        background: rgba(0,0,0,1);
    } */
    `;

export const TableMin = ({ children }) => {
    return (
        <TableBasic>
            {children}
        </TableBasic>
    )
}
